import CreateNewUserHA from './CreateNewUserHA';

export default CreateNewUserHA;
